export default __webpack_public_path__ + "static/media/home-min.e792f276.jpg";